import { render, staticRenderFns } from "./itemTwo.vue?vue&type=template&id=11e85e84"
import script from "./itemTwo.vue?vue&type=script&lang=js"
export * from "./itemTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports